$(document).ready(function(){
    if (jQuery('.sortable-table-date').length){
        jQuery('.sortable-table-date').dataTable({
            "searching": false,
            "info": false,
            "order": [[ 3, "desc" ]],
            "paging": false,
        });
    }

    if (jQuery('.sortable-table').length){
        jQuery('.sortable-table').dataTable({
            "searching": false,
            "info": false,
            "order": [[ 0, "asc" ]],
            "paging": false,
        });
    }

    if (jQuery('.sortable-table-no-sort').length){
        jQuery('.sortable-table-no-sort').dataTable({
            "searching": false,
            "info": false,
            "paging": false,
            "aaSorting": []
        });
    }


    if ($('.sortable-table-solicitors').length)
    {
        $('.sortable-table-solicitors').dataTable(
        {
            "searching": true,
            "info": true,
            "paging": true,
            "pageLength": 50,
            //"pagingType" : "simple",
            //"lengthMenu": [ [10, 25, 50, -1], [10, 25, 50, "All"] ],
            "language": {
                search: '<i class="fa fa-filter" aria-hidden="true"></i><span class="show-for-sr">Filter</span>',
                searchPlaceholder: 'Search for a Solicitor'
            },
            "dom": 'fltip',
            "order": [[ 0, "asc" ]],
            
        });
    

    }

    //$.fn.dataTableExt.sErrMode = 'throw';

});

